var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import { hasValue, trimSlash } from "../../utils";
export function registerLocalization(messages) {
    let Messages = window.UXPMessages;
    if (!Messages) {
        Messages = {};
    }
    // remove duplicates and merge the rest 
    for (const code of Object.keys(messages)) {
        if (!Messages[code]) {
            Messages[code] = messages[code];
        }
    }
    window.UXPMessages = Messages;
}
/**
 * Returns registered UXP messages for the selected language.
 * @export
 */
export function getRegisterMessages(language) {
    const allMessages = window.UXPMessages || {};
    const messages = {};
    for (const code of Object.keys(allMessages)) {
        messages[code.toLowerCase()] = allMessages[code][language];
    }
    return messages;
}
export function getRegisterMessagesByCode(code) {
    const allMessages = window.UXPMessages || {};
    return allMessages[code] || allMessages[code.toLowerCase()] || {};
}
// this will return messages for selected language
export function getCustomMessages() {
    var _a;
    return (((_a = window.ServiceDesk) === null || _a === void 0 ? void 0 : _a.__AppMessages__) || {});
}
export function localize(language, code, params) {
    if (!hasValue(code))
        return code;
    // check registere messages 
    const embededMessages = getRegisterMessages(language); // these are build in to the widget 
    const customMessages = getCustomMessages(); // comming from database 
    if (Object.keys(customMessages).length === 0 && Object.keys(embededMessages).length === 0)
        return code;
    let localizedMessage = hasValue(customMessages[code.toLowerCase()]) ? customMessages[code.toLowerCase()] : embededMessages[code.toLowerCase()];
    if (!hasValue(localizedMessage))
        return code;
    // replace params 
    if (params && Object.keys(params).length > 0) {
        for (const key of Object.keys(params)) {
            localizedMessage = localizedMessage.replace(`$${key}`, params[key]);
        }
    }
    return localizedMessage;
}
export function getEnabledLanguages(languages) {
    if (!languages || (languages === null || languages === void 0 ? void 0 : languages.length) == 0)
        return [];
    return (languages || []).map(l => { var _a; return (Object.assign(Object.assign({}, l), { Direction: ((_a = l === null || l === void 0 ? void 0 : l.Code) === null || _a === void 0 ? void 0 : _a.startsWith('ar')) ? 'rtl' : 'ltr' })); });
}
export function onChangeLanguage(uxpContext, language) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const url = trimSlash(uxpContext.lucyUrl) + `/User/updatelanguage?language=${language}&userkey=${uxpContext.userKey}`;
            const res = yield axios.get(url);
            window.location.reload();
        }
        catch (e) {
            console.log('Unable to update the language. Error: ', e);
        }
    });
}
export function updateDirectionBasedOnLanguage(language, languages) {
    const lang = languages.find(l => l.Code == language);
    if (lang && lang.Direction == 'rtl') {
        document.documentElement.setAttribute('dir', 'rtl');
        return 'rtl';
    }
    else {
        document.documentElement.removeAttribute('dir');
        return 'ltr';
    }
}
